import { render, staticRenderFns } from "./VeHrHetongManageList.vue?vue&type=template&id=64845130&scoped=true"
import script from "./VeHrHetongManageList.vue?vue&type=script&lang=js"
export * from "./VeHrHetongManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64845130",
  null
  
)

export default component.exports